














import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";


@Component({
  components: {
    Footer, Header
  },
})
export default class ErrorPage extends Vue {

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/404/ErrorPage.vue